import { CharField, ImageField, NumberField, SwitchField } from "@inmagik/magik-ui"
import { FieldArray, getIn, useFormikContext } from "formik"
import { Col, Row } from "react-bootstrap"
import type { Blog } from "../../types"

export default function BlogForm({ col = 8 }: { col?: number }) {
  const { setFieldValue, values, errors, submitCount } = useFormikContext<Blog>()

  return (
    <Col xs={col} className="d-flex flex-column align-items-stretch gap-4">
      <CharField
        label="Titolo"
        layout="horizontal"
        value={values.title}
        onChange={(value) => {
          setFieldValue("title", value)
        }}
        isValid={submitCount > 0 ? !getIn(errors, "title") : undefined}
        errorMessage={getIn(errors, "title")}
        required
      />
      <CharField
        label="Autore"
        layout="horizontal"
        value={values.author}
        onChange={(value) => {
          setFieldValue("author", value)
        }}
        isValid={submitCount > 0 ? !getIn(errors, "author") : undefined}
        errorMessage={getIn(errors, "author")}
        required
      />
      <ImageField
        label="Immagine di copertina"
        required
        layout="horizontal"
        value={values.cover}
        onChange={(value) => {
          setFieldValue("cover", value)
        }}
        isValid={submitCount > 0 ? !getIn(errors, "cover") : undefined}
        errorMessage={getIn(errors, "cover")}
      />
      <NumberField
        label="Tempo di lettura (minuti)"
        layout="horizontal"
        value={values.reading_time || 0}
        onChange={(value) => {
          setFieldValue("reading_time", value)
        }}
        isValid={submitCount > 0 ? !getIn(errors, "reading_time") : undefined}
        errorMessage={getIn(errors, "reading_time")}
      />
      <CharField
        label="Data"
        layout="horizontal"
        value={values.date || ""}
        onChange={(value) => {
          setFieldValue("date", value)
        }}
        isValid={submitCount > 0 ? !getIn(errors, "date") : undefined}
        errorMessage={getIn(errors, "date")}
      />
      <FieldArray name="tags">
        {({ push, remove }) => (
          <>
            {(values.tags || []).map((tag, index) => (
              <>
                <CharField
                  layout="horizontal"
                  label="Tag"
                  inputColSize={8}
                  value={tag}
                  onChange={(value) => {
                    setFieldValue(`tags.${index}`, value)
                  }}
                  isValid={submitCount > 0 ? !getIn(errors, `tags.${index}`) : undefined}
                  errorMessage={getIn(errors, `tags.${index}`)}
                />
                <Row>
                  <Col md={4} />
                  <Col md={8}>
                    <button
                      type="button"
                      style={{ width: "fit-content" }}
                      className="btn btn-danger"
                      onClick={() => {
                        remove(index)
                      }}
                    >
                      Rimuovi
                    </button>
                  </Col>
                </Row>
              </>
            ))}
            <Row>
              <Col md={4} />
              <Col md={8}>
                <button
                  type="button"
                  className="btn btn-primary mt-2"
                  onClick={() => {
                    push("")
                  }}
                >
                  Aggiungi tag
                </button>
              </Col>
            </Row>
          </>
        )}
      </FieldArray>
      <SwitchField
        label="Bozza"
        layout="horizontal"
        value={values.draft || false}
        onChange={(checked) => {
          setFieldValue("draft", checked)
        }}
      />
    </Col>
  )
}
